export default __webpack_public_path__ + "static/media/shadow-soft-summer.1b76b456.png";